module.exports = __webpack_public_path__ + "static/index/img/ok.30ced929.png";